import { FC } from 'react'

export type TargetsModalMessageProps = {
  message: string
}

const TargetsModalMessage: FC<TargetsModalMessageProps> = ({ message }) => {
  return (
    <div className="targetsModalMessage">
      <sup>*</sup>
      <span>{message}</span>
    </div>
  )
}

const TargetsModalAsterisk: FC = () => {
  return <sup style={{ marginLeft: '1px' }}>*</sup>
}

export { TargetsModalMessage, TargetsModalAsterisk }
